import React, { useContext } from "react";
import "./TermsAndCondsPage.css"
import {LanguageContext} from "../../context/LanguageContext"

const TermsAndCondsPage = () => {

    const {t} = useContext(LanguageContext);
    window.scroll(0,0);
    return(
        <div className="terms-n-conditions-container">
            <h1>{t("termsAndConditions","title")}</h1>
            {t("termsAndConditions","content").map((part,index)=>(
            <p key={index}>{part}</p>
            ))}
        </div>
    )
}
export default TermsAndCondsPage;